import ScreenDetectionDirective from './screen-detection-directive';
import ScreenDetectionService from './screen-detection-service';
import IfDesktopDirective from './if-desktop-directive';
import IfMobileDirective from './if-mobile-directive';

const MODULE_NAME = 'app.common.screen-detection';
const module = angular.module(MODULE_NAME, [])
    .directive(IfDesktopDirective.DIRECTIVE_NAME, IfDesktopDirective)
    .directive(IfMobileDirective.DIRECTIVE_NAME, IfMobileDirective)
    .directive(ScreenDetectionDirective.DIRECTIVE_NAME, ScreenDetectionDirective)
    .service(ScreenDetectionService.SERVICE_NAME, ScreenDetectionService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/screen-detection/screen-detection-module.js